<mat-accordion id="audit-trail-accordion" multi="true">
  <mat-expansion-panel id="shop-floor-audit-trail-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mic-icon class="mr-2" icon="factory" fontSet="outlined"></mic-icon>
        {{ translationService.translate('shopFloorAuditTrailText') }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>

    <!-- Loader while fetching -->
    @if (loadingAuditTrail) {
    <div class="flex justify-center py-4">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
    }

    <!-- Table after data loaded -->
    @if (!loadingAuditTrail) {
    <div id="shop-floor-audit-trail-table-container" style="max-height: 300px; overflow-y: auto">
      <mic-table
        id="shop-floor-audit-trail-table"
        class="table-stripped"
        [config]="shopFloorTableConfig"
        [dataSource]="shopFloorAuditTrail"
      >
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
    </div>
    }
  </mat-expansion-panel>

  <!--<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mic-icon class="mr-2" icon="history" fontSet="outlined"></mic-icon>
        Back Office Audit Trail
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>
  </mat-expansion-panel>-->
</mat-accordion>
